/**
 * Financial
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PrintItem } from './printItem';
import { EventPackageContent } from './eventPackageContent';
import { S3File } from './s3File';


export interface PrintTemplate { 
    id?: string;
    editorState?: string | null;
    s3FileId?: string | null;
    idNavigation?: EventPackageContent;
    printItems?: Array<PrintItem> | null;
    s3File?: S3File;
}

